// extracted by mini-css-extract-plugin
module.exports = {"header":"card-content-with-header__header___1p18N","title":"card-content-with-header__title___3uUYy","subtitle":"card-content-with-header__subtitle___3Y6Xy"};